import { useQuery } from '@tanstack/react-query'
import { fetchPartiesByNation, partyKeys } from '@/services/parties'

export function usePartiesByNation(nationId: string | undefined) {
  const partiesQuery = useQuery({
    queryKey: partyKeys.byNation(nationId!),
    queryFn: () => fetchPartiesByNation(nationId!),
    enabled: !!nationId,
  })

  return {
    parties: partiesQuery.data,
    isLoading: partiesQuery.isLoading,
    error: partiesQuery.error,
  }
}
